<template>
    <v-container>
        <v-btn @click="FiltreyiSifirla()">Filtreyi Sıfırla</v-btn>
        <v-flex xs12 sm12 md12>
            <v-text-field hide-details v-model="filterData.TurKodu" label="Tur Kodu">
            </v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md12>
            <v-text-field hide-details v-model="filterData.TurAdi" label="Tur Adı">
            </v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md12>
            <v-text-field hide-details v-model="filterData.Gunduz" label="Gündüz">
            </v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md12>
            <v-text-field hide-details v-model="filterData.Gece" label="Gece">
            </v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md12>
            <v-text-field hide-details v-model="filterData.Kontenjan" label="Kontenjan">
            </v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md12>
            <v-text-field hide-details v-model="filterData.KalanKontenjan" label="Kalan Kontenjan">
            </v-text-field>
        </v-flex>
        <v-flex xs12 md12 sm12>
            <v-autocomplete v-model="filterData.BaslangicNoktasi" label="Başlangıç Noktası" item-text="Title"
                item-value="ParkurKod" :items="Parkurs"></v-autocomplete>
        </v-flex>
        <v-flex xs12 md12 sm12>
            <v-autocomplete v-model="filterData.VarisParkuru" label="Varış Parkur" item-text="Title"
                item-value="ParkurKod" :items="Parkurs"></v-autocomplete>
        </v-flex>
        <v-flex xs12 md12 sm12>
            <v-autocomplete v-model="filterData.DonusParkuru" label="Dönüş Parkur" item-text="Title"
                item-value="ParkurKod" :items="Parkurs"></v-autocomplete>

        </v-flex>
        <v-flex xs12 sm12 md12>
            <v-text-field hide-details v-model="filterData.Doviz" label="Döviz">
            </v-text-field>
        </v-flex>

    </v-container>
</template>
<script>
import auth from '../../../../api/auth'
import tools from '../../coper/tools';

export default {
    data() {
        return {
            filterData: {
                TurKodu: "",
                TurAdi: "",
                Gunduz: 0,
                Gece: 0,
                BaslangicNoktasi: "",
                VarisParkuru: "",
                DonusParkuru:"",
                Kontenjan: 0,
                KalanKontenjan: 0,
                Doviz: "EUR"
            },
            Parkurs: [],
        }
    },
    watch: {
        filterData: {
            deep: true,
            handler(newVal, oldVal) {
                this.$emit("update-filter", this.filterData)
            },
        }
    },
    mounted() {
        this.getParkurs();
    },
    methods: {
        getParkurs() {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            var params1 = {
                CompanyCode: credentials.SirketKodu
            }
            this.classdialog = false
            this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurList', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.Parkurs = response.body

            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })
        },
        FiltreyiSifirla(){
            this.filterData = {
                TurKodu: "",
                TurAdi: "",
                Gunduz: 0,
                Gece: 0,
                BaslangicNoktasi: "",
                VarisParkuru: "",
                DonusParkuru:"",
                Kontenjan: 0,
                KalanKontenjan: 0,
                Doviz: "EUR"
            }
        }
    }
}
</script>